// mixins/DebugDateMixin.js
export default {
  methods: {
    preserveDebugDate(query = {}) {
      // 現在のルートからdebugDateを取得
      const debugDate = this.$route.query.debugDate;
      // クエリにdebugDateを追加するが、元のクエリには影響しない
      return debugDate ? { ...query, debugDate } : query;
    },
  },
};
